import { Address } from '@spartacus/core'
import { Observable } from 'rxjs'

export abstract class MbMyAddressesAdapter {

  abstract load(endpoint: string): Observable<Address[]>
}
